import type { ApolloError } from 'apollo-client';

import { containsNetworkError } from '@confluence/network';
import { isUnauthorizedError } from '@confluence/error-boundary/entry-points/isUnauthorizedError';

export function isExpectedError(error: ApolloError) {
	const isUnauthorized =
		error?.graphQLErrors?.[0]?.message === 'unauthorized' || isUnauthorizedError(error);

	return isUnauthorized || containsNetworkError(error);
}
